function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
/* eslint-disable jsx-a11y/media-has-caption */

import { h, Component } from 'preact';
import SnapshotButton from "./SnapshotButton.js";
import RecordButton from "./RecordButton.js";
import RecordingLength from "./RecordingLength.js";
import VideoSourceSelect from "./VideoSourceSelect.js";
import SubmitButton from "./SubmitButton.js";
import DiscardButton from "./DiscardButton.js";
function isModeAvailable(modes, mode) {
  return modes.includes(mode);
}
var CameraScreen = /*#__PURE__*/function (_Component) {
  _inherits(CameraScreen, _Component);
  function CameraScreen() {
    _classCallCheck(this, CameraScreen);
    return _callSuper(this, CameraScreen, arguments);
  }
  _createClass(CameraScreen, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var onFocus = this.props.onFocus;
      onFocus();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var onStop = this.props.onStop;
      onStop();
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;
      var _this$props = this.props,
        src = _this$props.src,
        recordedVideo = _this$props.recordedVideo,
        recording = _this$props.recording,
        modes = _this$props.modes,
        supportsRecording = _this$props.supportsRecording,
        videoSources = _this$props.videoSources,
        showVideoSourceDropdown = _this$props.showVideoSourceDropdown,
        showRecordingLength = _this$props.showRecordingLength,
        onSubmit = _this$props.onSubmit,
        i18n = _this$props.i18n,
        mirror = _this$props.mirror,
        onSnapshot = _this$props.onSnapshot,
        onStartRecording = _this$props.onStartRecording,
        onStopRecording = _this$props.onStopRecording,
        onDiscardRecordedVideo = _this$props.onDiscardRecordedVideo,
        recordingLengthSeconds = _this$props.recordingLengthSeconds;
      var hasRecordedVideo = !!recordedVideo;
      var shouldShowRecordButton = !hasRecordedVideo && supportsRecording && (isModeAvailable(modes, 'video-only') || isModeAvailable(modes, 'audio-only') || isModeAvailable(modes, 'video-audio'));
      var shouldShowSnapshotButton = !hasRecordedVideo && isModeAvailable(modes, 'picture');
      var shouldShowRecordingLength = supportsRecording && showRecordingLength && !hasRecordedVideo;
      var shouldShowVideoSourceDropdown = showVideoSourceDropdown && videoSources && videoSources.length > 1;
      var videoProps = {
        playsInline: true
      };
      if (recordedVideo) {
        videoProps.muted = false;
        videoProps.controls = true;
        videoProps.src = recordedVideo;

        // reset srcObject in dom. If not resetted, stream sticks in element
        if (this.videoElement) {
          this.videoElement.srcObject = null;
        }
      } else {
        videoProps.muted = true;
        videoProps.autoPlay = true;
        // @ts-expect-error srcObject does not exist on <video> props
        videoProps.srcObject = src;
      }
      return h("div", {
        className: "uppy uppy-Webcam-container"
      }, h("div", {
        className: "uppy-Webcam-videoContainer"
      }, h("video", _extends({
        /* eslint-disable-next-line no-return-assign */
        ref: function ref(videoElement) {
          return _this.videoElement = videoElement;
        },
        className: "uppy-Webcam-video  ".concat(mirror ? 'uppy-Webcam-video--mirrored' : '')
        /* eslint-disable-next-line react/jsx-props-no-spreading */
      }, videoProps))), h("div", {
        className: "uppy-Webcam-footer"
      }, h("div", {
        className: "uppy-Webcam-videoSourceContainer"
      }, shouldShowVideoSourceDropdown ? VideoSourceSelect(this.props) : null), h("div", {
        className: "uppy-Webcam-buttonContainer"
      }, shouldShowSnapshotButton && h(SnapshotButton, {
        onSnapshot: onSnapshot,
        i18n: i18n
      }), shouldShowRecordButton && h(RecordButton, {
        recording: recording,
        onStartRecording: onStartRecording,
        onStopRecording: onStopRecording,
        i18n: i18n
      }), hasRecordedVideo && h(SubmitButton, {
        onSubmit: onSubmit,
        i18n: i18n
      }), hasRecordedVideo && h(DiscardButton, {
        onDiscard: onDiscardRecordedVideo,
        i18n: i18n
      })), h("div", {
        className: "uppy-Webcam-recordingLength"
      }, shouldShowRecordingLength && h(RecordingLength, {
        recordingLengthSeconds: recordingLengthSeconds,
        i18n: i18n
      }))));
    }
  }]);
  return CameraScreen;
}(Component);
export default CameraScreen;